import type { ComponentType } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import { useModuleEnabled } from '@/hooks/use-integrations'
import { CHANNEL_BY_KEY, ChannelIcon, isChannelKey, type ChannelKey } from './channel-catalog'
import { ZaloPersonalTab } from './zalo-personal-tab'
import { ZaloOaTab } from './zalo-oa-tab'
import { ZaloBotTab } from './zalo-bot-tab'
import { FacebookPageTab } from './facebook-page-tab'
import { TiktokShopTab } from './tiktok-shop-tab'
import { ShopeeTab } from './shopee-tab'
import { WebsiteChatTab } from './website-chat-tab'
import { PancakeTab } from './pancake-tab'
import { TelegramBotTab } from './telegram-bot-tab'
import { TelegramAppTab } from './telegram-app-tab'
import { BetaChannelSetup } from './beta-channel-setup'

/** Trang quản lý của các kênh đã chạy thật. Kênh beta dùng BetaChannelSetup. */
const BODIES: Partial<Record<ChannelKey, ComponentType>> = {
  'zalo-personal': ZaloPersonalTab,
  'zalo-oa': ZaloOaTab,
  'zalo-bot': ZaloBotTab,
  facebook: FacebookPageTab,
  'tiktok-shop': TiktokShopTab,
  shopee: ShopeeTab,
  website: WebsiteChatTab,
  pancake: PancakeTab,
  'telegram-bot': TelegramBotTab,
  'telegram-app': TelegramAppTab,
}

/** Trang quản lý tài khoản của một kênh. Route: /integrations/:channel */
export function ChannelDetailPage() {
  const { t } = useTranslation('chanCatalog')
  const { channel } = useParams()
  // Pancake nằm trong kho lưu trữ → ẩn. Xem shared/module-registry.ts.
  const pancakeOn = useModuleEnabled('pancake')

  if (!isChannelKey(channel) || (channel === 'pancake' && !pancakeOn)) {
    return <Navigate to="/integrations" replace />
  }
  const def = CHANNEL_BY_KEY[channel]
  const Body = BODIES[channel]
  if (def.comingSoon || (!def.beta && !Body)) return <Navigate to="/integrations" replace />

  return (
    <div className="space-y-4">
      <div className="flex h-14 items-center gap-3">
        <ChannelIcon def={def} />
        <h1 className="text-lg font-medium">{def.name}</h1>
        {def.kind === 'personal' ? (
          <Badge variant="warning">Cloud</Badge>
        ) : (
          <Badge variant="default">{t('detail.official')}</Badge>
        )}
        {def.beta && <Badge variant="secondary">Beta</Badge>}
      </div>
      {/* key: đổi kênh thì dựng lại từ đầu — không mang theo ô tìm kiếm, dòng đã chọn. */}
      {def.beta || !Body ? <BetaChannelSetup key={channel} def={def} /> : <Body key={channel} />}
    </div>
  )
}
